module.exports = __webpack_public_path__ + "static/img/demoImage2.288748e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demoImage2.png
// module id = DYUl
// module chunks = 3